module.exports = __webpack_public_path__ + "static/img/img-ptfw2x.d10e2c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-ptfw2x.png
// module id = 5Flu
// module chunks = 0